import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import Config from '../utils/config.service';
import AngularHelperService from '../services/angular-helper.service';

@Injectable({ providedIn: 'root' })
export default class ImageService {
	private httpClient: HttpClient = inject(HttpClient);
	private config: Config = inject(Config);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);

	store: any = {};
	
	getDimensions(url) {
		if (!url) return this.angularHelperService.getPromise().resolve({});
		if (this.store[url]) return this.angularHelperService.getPromise().resolve(this.store[url]);
		
		var deferred: any = this.angularHelperService.getDeferredPromise();
		
		var img: any = new Image();
		var classThis = this;
		img.onload = function() {
			classThis.store[url] = { height: this.height, width: this.width };
			deferred.resolve(classThis.store[url]);
		};
		img.onerror = () => {
			deferred.resolve({ error: 'Could not request image' });
		};
		img.src = url;
		
		return deferred.promise;
	}
	
	preloadImage(src) {
		if (!src) return this.angularHelperService.getPromise().resolve();
		var deferred: any = this.angularHelperService.getDeferredPromise();
		var img: any = new Image();
		
		img.onload = () => {
			deferred.resolve(img);
		};
		img.onabort = () => {
			deferred.reject(src);
		};
		img.onerror = () => {
			deferred.reject(src);
		};
		
		img.src = src;
		
		return deferred.promise;
	}
	
	preloadImages(images) {
		var promises: Array<any> = [];
		for (var i = 0, len = images.length; i < len; i++) {
			promises.push(this.preloadImage(images[i]));
		}
		
		return this.angularHelperService.getPromise().all(promises);
	}
	
	getImageUploadUrl(type, fileName) {
		switch (type) {
			case 'profile': return this.config.getRestUrl() + 'rest/post/picture/type/PROFILE_ALBUM/add/' + fileName;
			case 'cover': return this.config.getRestUrl() + 'rest/post/picture/type/COVER_ALBUM/add/' + fileName;
			default: throw new Error('Invalid image type');
		}
	}
	
	uploadImage(image, type, onSuccess, onError) {
		var url: any = this.getImageUploadUrl(type, image.file.name);
		var formData: any = new FormData();
		
		formData.append('image', image.file);
		
		this.httpClient.post(url, formData, {
			withCredentials: true
		}).toPromise().then(onSuccess).catch(onError);
	}
	
}